import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/config";
import Ornament from "../components/Ornament";
import useSEO from "../hooks/useSEO";

const LegalPage = ({ slug: propSlug }) => {
  const params = useParams();
  const slug = propSlug || params.slug;
  const [page, setPage] = useState(null);
  useSEO({
    title: page?.title || (slug === "cgv" ? "CGV / CGU" : "Mentions légales"),
    description: page?.title,
  });

  useEffect(() => {
    (async () => {
      try { const r = await api.get(`/legal/${slug}`); setPage(r.data); } catch { setPage(null); }
    })();
  }, [slug]);

  return (
    <div className="pt-32 pb-24 bg-[#171717] min-h-screen" data-testid={`legal-page-${slug}`}>
      <div className="max-w-3xl mx-auto px-6">
        <Ornament className="mb-6" />
        <h1 className="font-serif text-4xl sm:text-5xl text-white text-center mb-10">{page?.title || "Chargement…"}</h1>
        <div className="space-y-5 text-[#DDD4B2]/85 leading-relaxed">
          {page?.content.split("\n").map((line, i) => (
            <p key={i} className="whitespace-pre-wrap" dangerouslySetInnerHTML={{
              __html: line.replace(/\*\*(.+?)\*\*/g, '<strong class="text-[#9A8640] block mt-4 uppercase tracking-wider text-sm">$1</strong>')
            }} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
